var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMosaicHooterOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.932,
    height: 57.389,
    viewBox: "0 0 37.932 57.389",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3327",
    "data-name": "Group 3327",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M35.346,30.407c0-.155-.01-.305-.021-.456l-.007-.032.011-.176c.008-.123.017-.245.017-.369A16.66,16.66,0,0,0,18.578,12.862,16.66,16.66,0,0,0,1.81,29.374c0,.12.007.239.015.358l.011.1-.009.151c-.009.139-.017.279-.017.421v22.75H35.346ZM3.82,29.6c0-.074-.01-.148-.01-.222A14.658,14.658,0,0,1,18.578,14.862,14.658,14.658,0,0,1,33.346,29.374c0,.075-.007.149-.012.223l-.014.35.01.146c.007.1.016.207.016.314V45.471H3.81V30.407c0-.1.006-.194.013-.29l.011-.26c0-.087-.008-.174-.014-.261M3.81,47.471H33.346v3.686H3.81Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M36.932,55.388H1a1,1,0,0,0,0,2H36.932a1,1,0,0,0,0-2",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M5.727,3.98a1,1,0,1,0-1.37,1.457l6.683,6.285a1,1,0,0,0,1.371-1.457Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M32.155,2.743a1,1,0,0,0-1.4.226l-5.371,7.438a1,1,0,1,0,1.622,1.171l5.371-7.439a1,1,0,0,0-.226-1.4",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M19.766,10.125,19.388.958A1.014,1.014,0,0,0,18.348,0a1,1,0,0,0-.958,1.041l.378,9.166a1,1,0,0,0,1,.959h.042a1,1,0,0,0,.958-1.04",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M28.81,29.36a1,1,0,0,0,1-1c0-6.3-6.18-9.039-9.448-9.6a1,1,0,1,0-.341,1.971c.078.013,7.789,1.42,7.789,7.633a1,1,0,0,0,1,1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M28.884,31.912a1,1,0,0,0-1,1v9.88a1,1,0,0,0,2,0v-9.88a1,1,0,0,0-1-1",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMosaicHooterOn);
export default __webpack_public_path__ + "static/media/MosaicHooterOn.8e61566a766b3bfbb7f39abab9eb819a.svg";
export { ForwardRef as ReactComponent };